import React from 'react';
import { Link } from 'react-router-dom';
import '../LandingPageNYC/landingPageNYC.css';

const MobileLeftSF = () => (
  <div className="nyc-vehicle-types__column--plus">
    <h1 className="nyc-vehicle-types__header">EV</h1>
    <p className="nyc-vehicle-types__text nyc-vehicle-types__text--small">
      Starting at
    </p>
    <h4 className="nyc-vehicle-types__subheader nyc-vehicle-types__subheader--plus">
      <div className="nyc-vehicle-types__subheader--rate">$7</div>
      <div className="nyc-vehicle-types__subheader--hr">/hr</div>
    </h4>
    <p className="nyc-vehicle-types__text nyc-vehicle-types__text--bold">
      What's included
    </p>
    <p className="section-1__text section-1__text--blurb">
      Unlimited Mileage <br />
      Full maintenance <br />
      Comprehensive Insurance <br />
      Roadside Assistance <br />
      24/7 Emergency Support
    </p>

    <p className="section-1__header section-1__header--medium section-1__header--medium--nyc">
      Vehicles
    </p>
    <p className="section-1__text section-1__text--blurb section-1__text--margin-right">
      Tesla Model 3
      <br />
    </p>

    <Link to={'/sf/ev'}>
      <button className="toronto-vehicle-types__learn-more">
        Learn More
      </button>
    </Link>
  </div>
);

export default MobileLeftSF;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/AutzuProMobileLeftSF.js